
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useRfmMonetary } from '@/modules/rfm/monetary/model/edit';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';

export default defineComponent({
    name: ROUTE_NAME_RFM.MONETARY.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, rfmGroupOptions, fetchRfmGroupAll, actions } = useRfmMonetary();

        onMounted(async () => {
            await fetchRfmGroupAll();
        });

        return { v$, model, rfmGroupOptions, actions };
    }
});
